/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

const isRetailOrSale = (prices) => {
    const retail = prices?.[0]?.value;
    const sale = prices?.[1]?.value;

    if (retail && sale && sale < retail) {
        return sale;
    }
    return retail;
};

export default isRetailOrSale;
